export default function getDistance(address1: any, address2: any) {
    const { latitude: latitude1 = 0, longitude: longitude1 = 0 } = address1;
    const { latitude: latitude2 = 0, longitude: longitude2 = 0 } = address2;
    const value = (latitude2 - latitude1) * (latitude2 - latitude1) + (longitude2 - longitude1) * (longitude2 - longitude1);
    return Math.pow(value, 0.5)
}